import { getMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const GET_PRACTICE_DETAIL = 'GET_PRACTICE_DETAIL';
export const GET_PRACTICE_DETAIL_SUCCESS = 'GET_PRACTICE_DETAIL_SUCCESS';
export const GET_PRACTICE_DETAIL_FAILURE = 'GET_PRACTICE_DETAIL_FAILURE';

// Action Creators
export const getPracticeDetailRequest = () => ({
  type: GET_PRACTICE_DETAIL,
});

export const getPracticeDetailSuccess = (users) => ({
  type: GET_PRACTICE_DETAIL_SUCCESS,
  payload: users,
});

export const getPracticeDetailFailure = (error) => ({
  type: GET_PRACTICE_DETAIL_FAILURE,
  payload: error,
});

// Thunk Function
export const getPracticeDetail = (external, id) => {
  return async (dispatch) => {
    dispatch(getPracticeDetailRequest());
    try {
      const response = await getMethodWithToken(
        url.getPracticeDetail + id + '/'
      );
      if (response?.status === 200 || response?.status === 201) {
        dispatch(getPracticeDetailSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
      }
    } catch (error) {
      dispatch(getPracticeDetailFailure(error?.message));
    }
  };
};
